import video from './video/video'
import imageStrip from './sliders/image-strip'
import accordion from './accordion/accordion'
import mobileMenu from './menus/mobile/mobile-menu'
import timelineSlider from './sliders/timeline/timeline'
import sideThumbsNavigation from './sliders/side-thumbs-navigation/side-thumbs-navigation'
import shareDrawer from './share-buttons/share'
import searchAutocomplete from './search-autocomplete/search-autocomplete'
import offsetTabBar from './tab-bars/offset-tab-bar'
import modal from './modals/modal'
import manageCalculator from './calculator/calculator'
import manageMxCalculator from './calculator/mx-calculator'

/**
 * Molecules functions.
 */
export default function molecules() {
  video()
  imageStrip()
  accordion()
  mobileMenu()
  timelineSlider()
  sideThumbsNavigation()
  shareDrawer()
  searchAutocomplete()
  offsetTabBar()
  modal()
  manageCalculator()

  if ( document.querySelector( '.js-mx-calc' ) ) {
    manageMxCalculator()
  }
}
